
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_ig8mp_1nzun_99",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_ig8mp_1nzun_1",
  "tutorial-list": "awsui_tutorial-list_ig8mp_1nzun_125",
  "tutorial-box": "awsui_tutorial-box_ig8mp_1nzun_164",
  "tutorial-box-title": "awsui_tutorial-box-title_ig8mp_1nzun_211",
  "tutorial-description-plaintext": "awsui_tutorial-description-plaintext_ig8mp_1nzun_217",
  "tutorial-description": "awsui_tutorial-description_ig8mp_1nzun_217",
  "expandable-section": "awsui_expandable-section_ig8mp_1nzun_229",
  "expanded": "awsui_expanded_ig8mp_1nzun_233",
  "button-wrapper": "awsui_button-wrapper_ig8mp_1nzun_237",
  "start": "awsui_start_ig8mp_1nzun_242",
  "expand-button": "awsui_expand-button_ig8mp_1nzun_246",
  "collapse-button": "awsui_collapse-button_ig8mp_1nzun_250",
  "learn-more-link": "awsui_learn-more-link_ig8mp_1nzun_254",
  "title": "awsui_title_ig8mp_1nzun_258",
  "prerequisites-alert": "awsui_prerequisites-alert_ig8mp_1nzun_262",
  "completed": "awsui_completed_ig8mp_1nzun_266",
  "download-link": "awsui_download-link_ig8mp_1nzun_270"
};
  